
    const data = {"name":"src/core/icons/arrow-down-thick","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 4h4v9l3.5-3.5 2.42 2.42L12 19.84l-7.92-7.92L6.5 9.5 10 13V4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            